import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

const TypeSignatureArea = ({ typedSignature, handleTypedSignatureChange, clearSignature, onColorChange }) => {
    const [selectedColor, setSelectedColor] = useState("#000000");

    const handleColorChange = (color) => {
        setSelectedColor(color);
        if (onColorChange) {
            onColorChange(color);
        }
    };

    return (
        <div className="tw-w-full tw-bg-white tw-h-[472px] tw-border tw-rounded-xl tw-p-4 tw-relative">
            {/* Signature Pad */}
            <input
                type="text"
                value={typedSignature}
                onChange={handleTypedSignatureChange}
                placeholder="Type your signature here"
                className="tw-w-full tw-p-2 tw-border-b tw-border-gray-300 tw-mt-[80px]"
                style={{
                    fontSize: "24px",
                    textAlign: "center",
                    padding: "10px",
                    color: selectedColor,
                }}
            />
            <p
                className="tw-mt-50"
                style={{
                    fontSize: "24px",
                    textAlign: "center",
                    padding: "10px",
                    color: selectedColor,
                    fontFamily: "cursive",
                }}
            >
                {typedSignature}
            </p>
            <div className="tw-p-4 tw-flex tw-bg-white tw-w-full tw-justify-between tw-absolute tw-bottom-5 tw-left-0">
                {/* Color Selection */}
                <div className="tw-flex tw-justify-start tw-gap-2 tw-mt-2">
                    {["#000000", "#FF5733", "#1D4ED8"].map((color) => (
                        <button
                            key={color}
                            className="tw-w-6 tw-h-6 tw-rounded-full tw-border"
                            style={{
                                backgroundColor: color,
                                border: selectedColor === color ? "2px solid #fff" : "none",
                            }}
                            onClick={() => handleColorChange(color)}
                        />
                    ))}
                </div>{" "}
                {/* Clear Button */}
                <button onClick={clearSignature} className="tw-mt-2  tw-px-3 tw-py-1 tw-rounded tw-text-sm">
                    Clear
                </button>
            </div>
        </div>
    );
};

export default TypeSignatureArea;
